import logo from './assets/logotype/logo.jpg';
import { useState, useEffect } from 'react';
import Menu from './Menu';

const Navigation = () => {
  const [width, setWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <nav className='navigation'>
      <Menu />
      <h1>Enchanted Crystals</h1>
      <div className='logo'>
        {width < 440 ? (
          <img
            style={{ width: '30px', height: '30px' }}
            src={logo}
            alt='logotype'
          />
        ) : width < 768 ? (
          <img
            style={{ width: '50px', height: '50px' }}
            src={logo}
            alt='logotype'
          />
        ) : (
          <img
            style={{ width: '80px', height: '80px' }}
            src={logo}
            alt='logotype'
          />
        )}
      </div>
    </nav>
  );
};

export default Navigation;
